/**
 * Shell chooser. The routing layer renders <AppShell /> as the layout root,
 * and the shell picks chrome based on URL prefix:
 *  - `/admin/...`   → `AdminShell` (operating system, gated)
 *  - `/events/:slug/...` → `PublicShell` (event-scoped fan view)
 *  - everything else → `MarketingShell` (front door, about, contact, sign-in)
 */
import { useLocation } from 'react-router-dom';
import { AdminShell } from './AdminShell';
import { CompanyShell } from './CompanyShell';
import { PublicShell } from './PublicShell';
import { MarketingShell } from './MarketingShell';

export function AppShell() {
  const { pathname } = useLocation();
  if (pathname.startsWith('/company')) return <CompanyShell />;
  if (pathname.startsWith('/admin')) return <AdminShell />;
  if (pathname.startsWith('/events/')) return <PublicShell />;
  return <MarketingShell />;
}
